import React from 'react'

export default function Selected() {
  return (
    <>
        <svg width="100%" height="100%" viewBox="0 0 75 69" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M75 67L0 0H60C68.2843 0 75 6.71573 75 15V67Z" fill="#3CFF49"/>
<path d="M63.3235 14.5802C63.7399 14.9673 63.9829 15.5012 63.9991 16.0645C64.0153 16.6277 63.8034 17.1743 63.4099 17.5839L51.1622 30.3354C50.9637 30.5417 50.7251 30.7068 50.4606 30.8209C50.1962 30.935 49.9111 30.9958 49.6223 30.9998C49.3335 31.0038 49.0468 30.9508 48.7792 30.8439C48.5116 30.7371 48.2685 30.5787 48.0642 30.3779L41.5801 24.0022C41.1983 23.5993 40.9905 23.0664 41.0003 22.5158C41.0102 21.9653 41.2371 21.4399 41.6331 21.0506C42.0291 20.6612 42.5633 20.4381 43.1232 20.4284C43.6832 20.4187 44.2251 20.6231 44.6348 20.9985L49.5483 25.827L60.2687 14.6652C60.6624 14.2558 61.2053 14.0168 61.7782 14.0009C62.351 13.9849 62.9068 14.1933 63.3235 14.5802Z" fill="white"/>
</svg>

    </>
  )
}
